<template>
  <v-container fluid class="asc-mx-rec-investigate-template px-0 pt-0">
    <v-row>
      <v-col>
        <asc-mx-rec-info-wrapper
          :is-investigation-tab="!isOnRecommendationTab"
          :is-recommendation-tab="isOnRecommendationTab"
          :tab-index="tabIndex"
          :is-pre-submittal="isPreSubmittal"
          :disable-submit="isDisableSubmit"
          :lock-enabled="pageLockedForEditing"
          :airline-tier-type-id="airlineTierTypeId"
          :is-custom-alert="isCustomAlert"
        />
      </v-col>
    </v-row>

    <v-row v-if="!isCurrentViewIssueUpdater && !isOnRecommendationTab">
      <v-col>
        <asc-mx-rec-title-wrapper
          :is-recommendation-tab="isOnRecommendationTab"
          :is-pre-submittal="isPreSubmittal"
          :fields="mxRecTitleFormFields"
          :title-length="45"
          :lock-enabled="pageLockedForEditing"
          :airline-tier-type-id="airlineTierTypeId"
          @mxRecTitleInput="handleMxRecTitleInput"
        />
      </v-col>
    </v-row>

    <v-row>
      <v-col v-if="isOnRecommendationTab" class="mr-4" :grow="true">
        <asc-mx-rec-recommendation-wrapper
          :status-options="statusOptions"
          :data="getRecommendationInfo"
          :custom-alert-mx-rec-status-options="customAlertMxRecStatusOptions"
          :airline-tier-type-id="airlineTierTypeId"
          @updateStatus="handleUpdateStatus"
        />
      </v-col>
      <v-col
        :class="!isOnRecommendationTab ? 'mr-md-4' : null"
        cols="12"
        md="8"
        class="pa-0"
      >
        <asc-mx-rec-detail-wrapper
          class="asc-mxrec-detail"
          :class="{
            'mr-0': isMxRecEditPermission,
          }"
          :data="getAlertDetailsInfo"
          :is-investigation-tab="!isOnRecommendationTab"
          :is-recommendation-tab="isOnRecommendationTab"
          :severity-options="severityOptions"
          :loading="aircraftDetailsLoading"
          :disabled="pageLockedForEditing"
          :is-support-info-loading="isSupportInfoLoading"
          :is-custom-alert="isCustomAlert"
          @updateMxRecAlertDetails="handleUpdateMxRecAlertDetails"
          @viewPHMAlerts="handleViewPHMAlerts"
          @followUpDataChanges="handleFollowUpDataChanges"
        />
      </v-col>
      <v-col
        v-if="
          (isCurrentViewIssueInvestigator || isCurrentViewIssueReader) &&
          !isOnRecommendationTab
        "
        class="mt-sm-4 mt-md-0"
      >
        <asc-mx-rec-status-wrapper
          v-if="!isCurrentViewIssueUpdater"
          :status-options="statusOptions"
          :locked-items="getLockedStatusOptions"
          :data="statusInfo"
          :investigation-users-to-tag="investigationUsersToTag"
          :is-pre-submittal="isPreSubmittal"
          :show-warning="showWarning"
          :disabled="pageLockedForEditing"
          :airline-tier-type-id="airlineTierTypeId"
          :issue-source="aircraftDetails.source"
          @updateStatusInfo="handleUpdateStatusInfo"
          @updateStatus="handleUpdateStatus"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <asc-accordion :value="isCurrentViewIssueUpdater ? 0 : undefined" flat>
          <asc-accordion-item>
            <template slot="header">
              <asc-required-label
                label="Maintenance Recommendation Details"
                :required="
                  isCurrentViewIssueInvestigator && !isOnRecommendationTab
                "
                uppercase
              >
              </asc-required-label>
            </template>
            <asc-mx-rec-recommendation-details-wrapper
              ref="maintenanceRecommendation"
              :max="3500"
              :fields="mxRecDetailsFormFields"
              :is-recommendation-tab="isOnRecommendationTab"
              :empty-comment="emptyComment"
              :reset="resetMxRecRecommendation"
              :airline-tier-type-id="airlineTierTypeId"
              :lock-enabled="pageLockedForEditing"
              @input="handleMxRecRecommendationInput"
            />
          </asc-accordion-item>
        </asc-accordion>
      </v-col>
    </v-row>
    <v-row v-if="!isCurrentViewIssueUpdater && !isOnRecommendationTab">
      <v-col>
        <asc-accordion flat>
          <asc-accordion-item first>
            <template slot="header">Investigation Details</template>
            <v-row>
              <asc-mx-rec-validation-wrapper
                :data="getValidationInfo"
                :is-recommendation-tab="isOnRecommendationTab"
                :fix-effectiveness-options="fixEffectivenessOptions"
                :service-delivery-outcome-options="
                  serviceDeliveryOutcomeOptions
                "
                :analytic-detection-outcome-options="
                  analyticDetectionOutcomeOptions
                "
                :re-entrant-lock="pageLockedForEditing"
                @updateValidationInfo="handleUpdateValidationInfo"
              />
              <asc-mx-rec-conclude-wrapper
                :data="getConcludeInfo"
                :is-recommendation-tab="isOnRecommendationTab"
                :reason-to-close-options="reasonToCloseOptions"
                :re-entrant-lock="pageLockedForEditing"
                @updateConcludeInfo="handleUpdateConcludeInfo"
              />
            </v-row>
            <v-row>
              <v-col>
                <asc-mx-rec-attachments-wrapper
                  :files="getInvestigationValidationAttachments"
                  :file-type-properties="
                    getFileTypeProperties('InvestigationValidationAttachments')
                  "
                  :mx-rec-attachment-error="flightSenseUploadError"
                  :is-recommendation-tab="isOnRecommendationTab"
                  :handle-update-attachment-caption="
                    handleUpdateAttachmentCaption
                  "
                  :show-attachments-header="false"
                  :can-edit-attachment-captions="isCurrentViewIssueInvestigator"
                  :lock-enabled="pageLockedForEditing"
                  @downloadFile="handleFileDownload"
                  @fileSelected="handleFileSelected"
                  @fileUploaded="handleFileUpload"
                />
              </v-col>
            </v-row>
          </asc-accordion-item>
        </asc-accordion>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <asc-accordion flat>
          <asc-accordion-item first>
            <template slot="header">MAINTENANCE ACTION FOLLOW-UP</template>
            <v-row>
              <v-col>
                <asc-mx-rec-follow-up-wrapper
                  :is-recommendation-tab="isOnRecommendationTab"
                  :is-custom-alert="isCustomAlert"
                  :data="getMxRecFollowUpInfo"
                  :files="getMaintenanceAttachments"
                  :file-type-properties="getFileTypeProperties('MaintIssue')"
                  :mx-action-attachment-upload-error="
                    mxActionAttachmentUploadError
                  "
                  :disabled="pageLockedForEditing"
                  :airline-response-options="airlineResponseOptions"
                  :details-discussion="detailsDiscussion"
                  :details-status-updates="detailsStatusUpdates"
                  :is-details-discussion-loading="isDetailsDiscussionLoading"
                  :details-discussion-type-id="detailsDiscussionTypeId"
                  :user="user"
                  :loading="aircraftDetailsLoading"
                  :users-to-tag="detailsUsersToTag"
                  :reset-comment="resetDetailsComment"
                  :restore-discussions="restoreDiscussions"
                  :handle-update-attachment-caption="
                    handleUpdateAttachmentCaption
                  "
                  :airline-tier-type-id="airlineTierTypeId"
                  :lock-enabled="pageLockedForEditing"
                  @addUserComment="handleNewComment"
                  @deleteComment="handleDeleteUserComment"
                  @updateComment="handleUpdateUserComment"
                  @removeUnsavedComment="handleRemoveUnsavedComment"
                  @downloadFile="handleFileDownload"
                  @fileSelected="handleFileSelected"
                  @fileUploaded="handleFileUpload"
                  @updateFollowUpFields="handleUpdateMxRecFollowUpFields"
                  @followUpDataChanges="handleFollowUpDataChanges"
                />
              </v-col>
            </v-row>
          </asc-accordion-item>
        </asc-accordion>
      </v-col>
    </v-row>
    <v-row
      :class="[
        isCurrentViewIssueUpdater || isOnRecommendationTab
          ? 'investigationDiscussion--noDisplay'
          : '',
      ]"
    >
      <v-col>
        <asc-accordion class="investigationDiscussion--accordion" flat>
          <asc-accordion-item>
            <template slot="header">Investigation Discussion</template>
            <p v-if="isCurrentViewIssueInvestigator">
              Add a comment to the internal Collins communication thread. An
              email will be sent to tagged recipients upon saving.
            </p>
            <asc-user-comment-list-wrapper
              class="investigationDiscussion"
              :user-comments="investigationDiscussion"
              :user="user"
              :discussion-type-id="investigationDiscussionTypeId"
              :user-list="investigationUsersToTag"
              :reset-comment="resetInvestigationComment"
              :restore-discussions="restoreDiscussions"
              :disabled="
                isCurrentViewIssueReader ||
                pageLockedForEditing ||
                isInvestigationDiscussionLoading
              "
              @addComment="handleComment"
              @deleteComment="handleDeleteUserComment"
              @updateComment="handleUpdateUserComment"
              @removeUnsavedComment="handleRemoveUnsavedComment"
            />
          </asc-accordion-item>
        </asc-accordion>
      </v-col>
    </v-row>
    <v-row v-if="!isCustomAlert">
      <v-col>
        <asc-accordion class="relatedAlerts--accordion" flat>
          <asc-accordion-item first>
            <template slot="header">{{ getRelatedAlertsHeader }}</template>
            <asc-related-mx-recs-wrapper
              :values="relatedAlerts"
              :aircraft-details="aircraftDetails"
              :is-recommendation-tab="isOnRecommendationTab"
              :is-expanded="true"
            />
          </asc-accordion-item>
        </asc-accordion>
      </v-col>
    </v-row>
    <v-row class="mb-1">
      <v-col>
        <asc-mx-rec-support-info-wrapper
          :accordion-item-to-expand="accordionItemToExpand"
          :is-recommendation-tab="isOnRecommendationTab"
          :is-support-info-loading="isSupportInfoLoading"
          :is-plot-data-loading="isPlotDataLoading"
          :internal-user="internalUser"
          :attachments-data="getSupportingInfoAttachments"
          :page-plots="validPagePlots"
          :are-plots-editable="areCurrentViewPlotsEditable"
          :chart-data="chartData"
          :loading-plot-ids="loadingPlotIds"
          :on-apply-page-plot="onApplyPagePlot"
          :phm-alerts-data="getSupportingInfoPHMAlerts"
          :fault-messages-data="aircraftDetails.faultMessages"
          :removals-data="aircraftDetails.removalsData"
          :supporting-info-selection-types="supportingInfoSelectionTypes"
          :disabled="pageLockedForEditing"
          :hide-hidden-tabs="hideHiddenTabs"
          :on-toggle-page-plot-visibility="onTogglePagePlotVisibility"
          :on-update-page-plot-caption="onUpdatePagePlotCaption"
          :on-expand="onExpand"
          :on-add-tab-to-page-plot="onAddTabToPagePlot"
          :on-remove-tab-from-page-plot="onRemoveTabFromPagePlot"
          :on-update-tab-view-page-plot="onUpdateTabViewPagePlot"
          :airline-tier-type-id="airlineTierTypeId"
          :is-custom-alert="isCustomAlert"
          @onRowSelected="handleSupportInfoRowSelected"
          @onCaptionUpdate="handleUpdateCaption"
          @onAttachmentCaptionUpdate="handleUpdateAttachmentCaption"
          @onDownloadFile="handleFileDownload"
          @onFileSelected="handleFileSelected"
          @onFileUploaded="handleFileUpload"
          @onVisibilityReminder="handleVisibilityReminder"
          @onVisibilityConfirmation="handleConfirmingVisibility"
          @onRemovePlot="handleRemovePlot"
          @onPlotVisibility="handlePlotVisibility"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import AscAccordion from '../atoms/AscAccordion.vue'
import AscAccordionItem from '../atoms/AscAccordionItem.vue'
import AscRequiredLabel from '../atoms/AscRequiredLabel.vue'

import AscMxRecAttachmentsWrapper from '../organisms/AscMxRecAttachmentsWrapper.vue'
import AscMxRecConcludeWrapper from '../organisms/AscMxRecConcludeWrapper.vue'
import AscMxRecDetailWrapper from '../organisms/AscMxRecDetailWrapper.vue'
import AscMxRecFollowUpWrapper from '../organisms/AscMxRecFollowUpWrapper.vue'
import AscMxRecRecommendationDetailsWrapper from '../organisms/AscMxRecRecommendationDetailsWrapper.vue'
import AscMxRecRecommendationWrapper from '../organisms/AscMxRecRecommendationWrapper.vue'
import AscMxRecStatusWrapper from '../organisms/AscMxRecStatusWrapper.vue'
import AscMxRecSupportInfoWrapper from '../organisms/AscMxRecSupportInfoWrapper.vue'
import AscMxRecTitleWrapper from '../organisms/AscMxRecTitleWrapper.vue'
import AscMxRecValidationWrapper from '../organisms/AscMxRecValidationWrapper.vue'
import AscMxRecInfoWrapper from '../organisms/AscMxRecInfoWrapper.vue'
import AscRelatedMxRecsWrapper from '../organisms/AscRelatedMxRecsWrapper.vue'
import AscUserCommentListWrapper from '../organisms/AscUserCommentListWrapper.vue'

import AscUserCommentPropsMixin from '../mixins/AscUserCommentPropsMixin.vue'
import AscMxRecPropsMixin from '../mixins/AscMxRecPropsMixin.vue'
import AscMxRecPermissionMixin from '../mixins/AscMxRecPermissionMixin.vue'

import { COLLINS_PHM_TIER_3, COLLINS_PHM_TIER_4 } from '@/utilities/appConsts'

import variables from '@/styles/_varsJs.scss'

import _isEqual from 'lodash/isEqual'
import _sortBy from 'lodash/sortBy'
import moment from 'moment'

export default {
  name: 'AscMxRecInvestigateTemplate',

  components: {
    AscAccordion,
    AscAccordionItem,
    AscUserCommentListWrapper,
    AscRequiredLabel,
    AscMxRecInfoWrapper,
    AscMxRecDetailWrapper,
    AscMxRecTitleWrapper,
    AscMxRecStatusWrapper,
    AscMxRecFollowUpWrapper,
    AscMxRecAttachmentsWrapper,
    AscMxRecValidationWrapper,
    AscMxRecConcludeWrapper,
    AscMxRecRecommendationWrapper,
    AscMxRecRecommendationDetailsWrapper,
    AscRelatedMxRecsWrapper,
    AscMxRecSupportInfoWrapper,
  },

  mixins: [
    AscMxRecPropsMixin,
    AscUserCommentPropsMixin,
    AscMxRecPermissionMixin,
  ],

  props: {
    // Refer AscMxRecPropsMixin for rest of props
    issueId: {
      type: Number,
      required: true,
    },
    aircraftDetails: {
      type: Object,
      default: () => {},
    },
    statusInfo: {
      type: Object,
      default: () => {},
    },
    isDisableSubmit: {
      type: Boolean,
      default: true,
    },
    mxRecDetailsFormFields: {
      type: Object,
      default: () => {},
    },
    mxRecTitleFormFields: {
      type: Object,
      default: () => {},
    },
    aircraftDetailsLoading: {
      type: Boolean,
      default: false,
    },
    fileTypes: {
      type: Array,
      default: () => [],
    },
    isPlotDataLoading: {
      type: Boolean,
      default: false,
    },

    pagePlots: {
      type: Array,
      default: () => [],
    },
    arePlotsEditable: {
      type: Boolean,
      default: false,
    },
    loadingPlotIds: {
      type: Array,
      default: () => [],
    },
    chartData: {
      type: Array,
      default: () => [],
    },
    statusOptions: {
      type: Array,
      default: () => [],
    },
    lockedStatusOptions: {
      type: Array,
      default: () => [],
    },
    reEntrantLockObtained: {
      type: Boolean,
    },
    detailsDiscussion: {
      type: Array,
      default: () => [],
    },
    detailsStatusUpdates: {
      type: Array,
      default: () => [],
    },
    investigationDiscussion: {
      type: Array,
      default: () => [],
    },
    investigationDiscussionTypeId: {
      type: Number,
      required: true,
    },
    detailsDiscussionTypeId: {
      type: Number,
      required: true,
    },
    investigationUsersToTag: {
      type: Array,
      default: () => [],
    },
    detailsUsersToTag: {
      type: Array,
      default: () => [],
    },
    changesMade: {
      type: Boolean,
      default: false,
    },
    supportingInfoSelectionTypes: {
      type: Array,
      default: () => [],
    },
    supportAttachmentUploadError: {
      type: Array,
      default: () => [],
    },
    mxActionAttachmentUploadError: {
      type: Array,
      default: () => [],
    },
    flightSenseUploadError: {
      type: Array,
      default: () => [],
    },
    onApplyPagePlot: {
      type: Function,
      default: () => {},
    },
    isPlotDeletionSuccessful: {
      type: Object,
      default: () => {},
    },
    severityOptions: {
      type: Array,
      default: () => [],
    },
    airlineResponseOptions: {
      type: Array,
      default: () => [],
    },
    fixEffectivenessOptions: {
      type: Array,
      default: () => [],
    },
    serviceDeliveryOutcomeOptions: {
      type: Array,
      default: () => [],
    },
    analyticDetectionOutcomeOptions: {
      type: Array,
      default: () => [],
    },
    reasonToCloseOptions: {
      type: Array,
      default: () => [],
    },
    relatedAlerts: {
      type: Array,
      default: () => [],
    },
    resetDetailsComment: {
      type: Boolean,
      default: false,
    },
    resetInvestigationComment: {
      type: Boolean,
      default: false,
    },
    restoreDiscussions: {
      type: Boolean,
      default: false,
    },
    isManuallyCreated: {
      type: Boolean,
      default: false,
    },
    isSupportInfoLoading: {
      type: Boolean,
      default: false,
    },
    isDetailsDiscussionLoading: {
      type: Boolean,
      default: true,
    },
    isInvestigationDiscussionLoading: {
      type: Boolean,
      default: true,
    },
    hideHiddenTabs: {
      type: Boolean,
      default: true,
    },
    saveDisabled: {
      type: Boolean,
      default: true,
    },
    onTogglePagePlotVisibility: {
      type: Function,
      default: () => {},
    },
    onUpdatePagePlotCaption: {
      type: Function,
      default: () => {},
    },
    onExpand: {
      type: Function,
      default: () => {},
    },
    onAddTabToPagePlot: {
      type: Function,
      default: () => {},
    },
    onRemoveTabFromPagePlot: {
      type: Function,
      default: () => {},
    },
    onUpdateTabViewPagePlot: {
      type: Function,
      default: () => {},
    },
    customAlertMxRecStatusOptions: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      statusId: null,
      ownerUserId: null,
      mxRecFormData: null,
      maintenanceActionFollowUpFormData: {},
      // showMxRecHeaderAlert: false,
      accordionItemToExpand: [],
      emptyComment: '<p></p>',
      resetMxRecRecommendation: false,
      validPagePlots: this.pagePlots,
    }
  },

  computed: {
    areCurrentViewPlotsEditable() {
      return this.arePlotsEditable && !this.isOnRecommendationTab
    },

    isCurrentViewIssueInvestigator() {
      return this.isEditPermissionInvestigate && !this.isOnRecommendationTab
    },

    getLockedStatusOptions() {
      return this.lockedStatusOptions
    },

    isCurrentViewIssueReader() {
      return this.isReadOnlyPermissionInvestigate && !this.isOnRecommendationTab
    },

    isCurrentViewIssueUpdater() {
      return this.isMxRecEditPermission
    },

    getViewManagerData() {
      return {
        issueId: this.issueId,
        lastUpdatedBy: this.aircraftDetails?.lastUpdatedBy,
        updatedDate: this.aircraftDetails?.updatedDate,
        status: this.data?.status,
      }
    },

    pageLockedForEditing() {
      return this.reEntrantLockObtained
    },

    isOnRecommendationTab() {
      if (this.isMxRecEditPermission || this.isCustomAlert) {
        return true
      } else {
        return this.isRecommendationTab
      }
    },

    getValidationInfo() {
      return {
        fixEffectivenessId: this.aircraftDetails?.fixEffectivenessId,
        serviceDeliveryOutcomeId:
          this.aircraftDetails?.serviceDeliveryOutcomeId,
        analyticDetectionOutcomeId:
          this.aircraftDetails?.analyticDetectionOutcomeId,
        expectedServiceInterruptionMinutesSaved:
          this.aircraftDetails?.expectedServiceInterruptionMinutesSaved,
      }
    },

    getConcludeInfo() {
      return {
        mroLocation: this.aircraftDetails?.mroLocation,
        mroPOC: this.aircraftDetails?.mroPoc,
        reasonToCloseId: this.aircraftDetails?.closingReasonId,
        removalDate: this.aircraftDetails?.dateOfRemoval,
      }
    },

    getAlertDetailsInfo() {
      return {
        tail: this.aircraftDetails?.tail,
        model: this.aircraftDetails?.model,
        analyticModuleName: this.aircraftDetails?.analyticModuleName,
        system: this.aircraftDetails?.system,
        component: this.aircraftDetails?.component,
        alerts: this.aircraftDetails?.alerts,
        severityId: this.aircraftDetails?.severityId,
        partNumber: this.aircraftDetails?.partNumber,
        isManuallyCreated: this.isManuallyCreated,
        positionName: this.aircraftDetails?.positionName,
        customAlertSeverityLevel: this.aircraftDetails?.severityLevel,
      }
    },

    getMxRecFollowUpInfo() {
      return {
        airlineResponseId: this.aircraftDetails?.airlineResponseId
          ? this.aircraftDetails.airlineResponseId
          : 2,
        dateCompleted: this.aircraftDetails?.dateCompleted,
        serviceAlertNumber: this.aircraftDetails?.serviceAlertNumber,
        purchaseOrderNumber: this.aircraftDetails?.purchaseOrderNumber,
        removedPartNumber: this.aircraftDetails?.removedPartNumber,
        removedPartSerialNumber: this.aircraftDetails?.removedPartSerialNumber,
        installedPartNumber: this.aircraftDetails?.installedPartNumber,
        installedPartSerialNumber:
          this.aircraftDetails?.installedPartSerialNumber,
      }
    },

    getRecommendationInfo() {
      return {
        title: this.aircraftDetails?.title,
        status: this.aircraftDetails?.status,
        dateSubmitted: this.aircraftDetails?.dateSubmitted,
        createdDate: this.aircraftDetails?.createdDate, // For tier 3 and custom alert source we wont have submitted date
        manualIssueSource: this.isManuallyCreated,
        customAlertMxRec: this.isCustomAlert,
      }
    },

    lastUpdatedBy() {
      // Add user's name once it is added to mx issue data
      return this.aircraftDetails?.lastUpdatedBy &&
        this.aircraftDetails?.updatedDate
        ? `${this.aircraftDetails.lastUpdatedBy}, ${moment(
            this.aircraftDetails.updatedDate,
          ).format('hh:mm a, DD MMM YYYY')}`
        : ''
    },

    nameOptions() {
      return this.investigationUsersToTag.map(user => {
        return {
          email: user.userName,
          internal: true,
          text: `${user.firstName} ${user.lastName}`,
          value: user.userId,
        }
      })
    },

    getStatus() {
      // for all other roles/statuses, just return the name
      return this.aircraftDetails.status?.name
    },

    showWarning() {
      return (
        this.isOnRecommendationTab && this.isPreSubmittal && this.statusId <= 2
      )
    },

    getRequiredIconColor() {
      return variables.warningbase
    },

    getMaintenanceAttachments() {
      return this.aircraftDetails?.attachments?.filter(file =>
        file?.filename.match('MaintIssue'),
      )
    },

    getInvestigationValidationAttachments() {
      return this.aircraftDetails?.attachments?.filter(file =>
        file?.filename.match('InvestigationValidationAttachments'),
      )
    },

    getRelatedAlertsHeader() {
      const tailName = this.aircraftDetails?.tail?.name
        ? `for ${this.aircraftDetails?.tail?.name}`
        : ''

      const systemName = this.aircraftDetails?.system?.name
        ? ` (${this.aircraftDetails?.system?.name})`
        : ''

      const ataChapter = this.aircraftDetails?.ataChapter
        ? ` ${this.aircraftDetails?.ataChapter}`
        : ''

      return (this.isCurrentViewIssueInvestigator ||
        this.isCurrentViewIssueReader) &&
        !this.isOnRecommendationTab &&
        (this.airlineTierTypeId == COLLINS_PHM_TIER_3 ||
          this.airlineTierTypeId == COLLINS_PHM_TIER_4)
        ? `Related Issues for ATA ${ataChapter} ON ${
            this.aircraftDetails?.tail?.name
              ? this.aircraftDetails?.tail?.name
              : ''
          }`
        : this.isCurrentViewIssueReader && !this.isOnRecommendationTab
        ? `Related Alerts & Mx Recs ${tailName + systemName}`
        : `Related Mx Recs ${tailName + systemName}`
    },

    getSupportingInfoAttachments() {
      const attachments =
        this.aircraftDetails?.attachments?.filter(file =>
          file?.filename.match('SupportingInfo'),
        ) || []

      const selectedFiles = attachments.filter(attachment => {
        return attachment.isExternallyVisible
      })

      return {
        attachments: attachments,
        attachmentsCaption: this.aircraftDetails?.attachmentsCaption,
        selectedFiles: selectedFiles || [],
        fileTypeProperties: this.getFileTypeProperties('SupportingInfo'),
        attachmentUploadError: this.supportAttachmentUploadError,
      }
    },

    getSupportingInfoPHMAlerts() {
      // If alert is manually created then dont display PHM alerts
      return !this.isManuallyCreated &&
        this.aircraftDetails &&
        this.aircraftDetails.phmAlerts
        ? this.aircraftDetails.phmAlerts
        : {
            caption: '',
            grids: [],
            sectionTitle: '',
            selectedRows: [],
          }
    },
  },

  watch: {
    saveDisabled(newValue) {
      const changes = !newValue
      this.$emit('update:changesMade', changes)
      this.$emit('input', changes)
      this.$emit('change', changes)
    },

    'aircraftDetails.ownerUserId'(val) {
      if (val) this.ownerUserId = val
    },

    'aircraftDetails.status'(val) {
      if (val) {
        this.statusId = val.id
      }
    },

    isPlotDeletionSuccessful(newVal) {
      if (newVal.status) {
        this.$emit('isSaveDisabled', false)
      }
    },

    pagePlots: {
      deep: true,
      handler(pagePlots) {
        this.pagePlots = pagePlots
        this.loadValidPagePlots()
      },
    },
  },

  destroyed() {
    this.statusId = null
  },

  methods: {
    handleUpdatedFields(customAlertMxRecstatusdata) {
      const isEqual = _isEqual(
        customAlertMxRecstatusdata.status.id,
        customAlertMxRecstatusdata.customAlertMxRecstatusId,
      )
      if (!isEqual) {
        this.$emit('isSaveDisabled', false)
        this.$emit(
          'updateCustomAlertMxRecStatusDetails',
          customAlertMxRecstatusdata,
        )
      }
    },

    handleFileDownload(fileToDownload) {
      this.$emit('downloadFile', fileToDownload)
    },

    handleNewComment(commentInfo) {
      this.$emit('isSaveDisabled', false)
      this.$emit('addUserComment', commentInfo)
    },

    handleComment(commentInfo) {
      this.$emit('isSaveDisabled', false)
      this.$emit('newComment', commentInfo)
    },

    handleDeleteUserComment(commentInfo) {
      this.$emit('isSaveDisabled', false)
      this.$emit('deleteUserComment', commentInfo)
    },

    handleUpdateUserComment(commentInfo) {
      this.$emit('isSaveDisabled', false)
      this.$emit('updateUserComment', commentInfo)
    },

    handleRemoveUnsavedComment(comment) {
      this.$emit('removeUnsavedComment', comment)
    },

    handleSupportInfoRowSelected(rowInfo) {
      this.$emit('isSaveDisabled', false)
      this.$emit('rowSelected', rowInfo)
    },

    handleUpdateCaption(captionParams) {
      this.$emit('isSaveDisabled', false)
      this.$emit('updateCaption', captionParams)
    },

    handleUpdateAttachmentCaption(attachmentInfo) {
      this.$emit('isSaveDisabled', false)
      this.$emit('updateAttachmentCaption', attachmentInfo)
    },

    handleUpdateMxRecAlertDetails(details) {
      const isEqual = _isEqual(
        this.aircraftDetails?.severityId,
        details?.severityId,
      )
      if (!isEqual) {
        this.$emit('isSaveDisabled', false)
        // update store here
        this.$emit('updateMxRecAlertDetails', details)
      }
    },

    handleViewPHMAlerts() {
      this.accordionItemToExpand = ['PHM_ALERTS'] // PHM Accordion section title

      // Time out for accordion to expand
      setTimeout(() => {
        const element = document.getElementById('PHM_ALERTS')
        if (element) {
          element.scrollIntoView({
            behavior: 'smooth',
          })
        }
      }, 1000)
    },

    handleUpdateStatusInfo(statusData) {
      this.$emit('updateMxRecStatusDetails', statusData)
    },
    handleUpdateStatus(newStatusId) {
      this.$emit('updateMxRecStatusId', newStatusId)
    },

    handleUpdateValidationInfo(validationInfo) {
      const isEqual = _isEqual(
        _sortBy({ ...this.getValidationInfo }),
        _sortBy({ ...validationInfo }),
      )
      if (!isEqual) {
        this.$emit('isSaveDisabled', false)
        // Update store here
        this.$emit('updateMxRecValidationDetails', validationInfo)
      }
    },

    handleUpdateConcludeInfo(concludeInfo) {
      const isEqual = _isEqual(
        _sortBy({ ...this.getConcludeInfo }),
        _sortBy({ ...concludeInfo }),
      )
      if (!isEqual) {
        this.$emit('isSaveDisabled', false)
        // Update store here
        this.$emit('updateMxRecConcludeDetails', concludeInfo)
      }
    },

    handleUpdateMxRecFollowUpFields(followUpInfo) {
      const isEqual = _isEqual(
        _sortBy({ ...this.getMxRecFollowUpInfo }),
        _sortBy({ ...followUpInfo }),
      )

      if (!isEqual) {
        this.$emit('isSaveDisabled', false)
        this.$emit('updateMxRecFollowUpFields', followUpInfo)
      }
    },

    handleFollowUpDataChanges() {
      this.$emit('followUpDataChanges', true)
    },

    handleFileSelected(file) {
      this.$emit('isSaveDisabled', false)

      if (file.remove) {
        this.$emit('fileUpdate', file)
      } else if (file.cancel) {
        this.$emit('fileUpdate', { cancel: true, uploadToCancel: file })
      } else {
        this.$emit('fileUpdate', { update: true, fileToUpdate: file })
      }
    },

    handlePlotVisibility(plotOptions) {
      this.$emit('isSaveDisabled', false)
      this.$emit('onPlotVisibility', plotOptions)
    },

    handleFileUpload(file) {
      this.$emit('isSaveDisabled', false)
      this.$emit('fileUpdate', { fileToSave: file })
    },

    handleVisibilityReminder(sectionTitle) {
      this.supportInfoNotifications = [
        {
          mode: 'toast',
          text: `No ${sectionTitle} items are viewable in Mx Rec`,
          position: 'bottom',
          type: 'notice',
          color: 'notice',
          autoClose: true,
          dismissible: true,
          queue: true,
        },
      ]
    },

    handleConfirmingVisibility(sectionTitle) {
      this.supportInfoNotifications = [
        {
          mode: 'toast',
          text: `${sectionTitle} will be viewable in Mx Rec`,
          position: 'bottom',
          autoClose: true,
          color: 'notice',
          type: 'notice',
          dismissible: true,
          queue: true,
        },
      ]
    },

    handleSupportNotificationClose(notification) {
      this.supportInfoNotifications = this.supportInfoNotifications.filter(
        notificationObj => {
          return notificationObj.text !== notification.text
        },
      )
    },

    handleMxRecTitleInput(formData) {
      const isEqual = _isEqual(this.aircraftDetails?.title, formData?.title)

      if (!isEqual) {
        this.$emit('isSaveDisabled', false)
        this.resetMxRecRecommendation = false
      }

      if (!formData.valid) {
        //this.showMxRecHeaderAlert = false
        this.$emit('onAlert', {
          type: 'error',
          icon: 'mdi-alert-circle',
          text: 'All required fields must be filled in order to submit.',
          uppercase: true,
        })
      }
      this.$emit('updateMxRecTitle', formData?.title)
    },

    handleMxRecRecommendationInput(formData) {
      const isEqual = _isEqual(
        this.aircraftDetails?.recommendation,
        formData?.mxRecDetails,
      )
      if (!isEqual) {
        this.$emit('isSaveDisabled', false)
        this.resetMxRecRecommendation = false
      }

      if (!formData.valid) {
        // update the issue details object here so it can be sent with
        // the save action.  The form data is only for internal status
        // of the maintenance recommendation component
        // this.showMxRecHeaderAlert = false // Remove notification on valid
        this.$emit('onAlert', {
          type: 'error',
          icon: 'mdi-alert-circle',
          text: 'All required fields must be filled in order to submit.',
          uppercase: true,
        })
      }
      this.$emit('updateMxRecommendation', formData?.mxRecDetails)
    },

    handleRemovePlot(id) {
      this.$emit('onRemovePlot', id)
    },

    getFileTypeProperties(whichAttachmentType) {
      const attachmentFileType = this.fileTypes
        .filter(file => file.filenameSuffix === whichAttachmentType)
        .pop()
      return attachmentFileType
    },

    loadValidPagePlots() {
      this.validPagePlots = this.pagePlots

      if (
        !this.isCurrentViewIssueInvestigator &&
        !this.isCurrentViewIssueReader
      ) {
        if (this.airlineTierTypeId === COLLINS_PHM_TIER_3) {
          this.validPagePlots = this.pagePlots.filter(
            item => item.isExternallyVisible && !item.isFeaturePlot,
          )
        } else {
          this.validPagePlots = this.pagePlots.filter(item => item.plotVisible)
        }
      }
    },
  },
}
</script>

<style lang="scss">
.asc-mx-rec-investigate-template {
  position: relative;

  & > .row {
    margin: 0;
    margin-bottom: 16px;

    & > .col {
      padding: 0;
    }
  }

  .asc-accordion {
    position: initial;

    .asc-accordion--item--header {
      .asc-required-label {
        .required {
          margin: 0;
        }
      }
    }
  }

  .investigationDiscussion {
    max-height: 800px;
    overflow-y: scroll;
    padding: 13px;

    &--noDisplay {
      display: none;
    }
  }

  .relatedAlerts--accordion {
    width: 100%;
    position: relative;
    z-index: 2;

    & > .asc-accordion > .v-expansion-panel--active {
      min-height: 200px;
    }
  }
}
</style>
